const CDN_IMAGE_BASE_URL = import.meta.env.VITE_CDN_IMAGE_BASE_URL ?? '';

interface CdnImageOptions {
  width: number;
  height: number;
  fit?: string;
  format?: string;
}

export function getCdnImageUrl(imageUrl: string, options: CdnImageOptions): string {
  if (!CDN_IMAGE_BASE_URL || !imageUrl) return imageUrl;
  const { width, height, fit = 'cover', format = 'auto' } = options;
  return `${CDN_IMAGE_BASE_URL}width=${width},height=${height},fit=${fit},format=${format}/${imageUrl}`;
}
